// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMemberResponse

import { hydrateWidgetMyBooking, type WidgetMyBooking, type WidgetMyBookingApiResponse } from './widgetMyBooking.gen';
import { hydrateCustomerPackage, type CustomerPackage, type CustomerPackageApiResponse } from './customerPackage.gen';
import { hydrateGiftcardPublic, type GiftcardPublic, type GiftcardPublicApiResponse } from './giftcardPublic.gen';

export type WidgetMemberApiResponse = {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	phoneOptIn: boolean;
	emailOptIn: boolean;
	preferredLocale: string;
	bookings: WidgetMyBookingApiResponse[];
	customerPackages: CustomerPackageApiResponse[];
	giftcards: GiftcardPublicApiResponse[];
	paymentMethods: Array<string>;
};

export type WidgetMember = {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	phoneOptIn: boolean;
	emailOptIn: boolean;
	preferredLocale: string;
	bookings: WidgetMyBooking[];
	customerPackages: CustomerPackage[];
	giftcards: GiftcardPublic[];
	paymentMethods: Array<string>;
};

export function hydrateWidgetMember(data: WidgetMemberApiResponse): WidgetMember {
	return {
		...data,
		bookings: data.bookings.map(hydrateWidgetMyBooking),
		customerPackages: data.customerPackages.map(hydrateCustomerPackage),
		giftcards: data.giftcards.map(hydrateGiftcardPublic),
	};
}